"use client";
import { Container, Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";

export default function CertificateComp(index){
const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1100);
    handleResize(); // Set initial state
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const boxVariantsL = !isMobile
    ? {
        hidden: { opacity: 0, x: index % 2 === 0 ? 350 : -350 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.7 } },
      }
    : { hidden: { opacity: 1 }, visible: { opacity: 1 } };

  const boxVariantsR = !isMobile
    ? {
        hidden: { opacity: 0, x: index % 2 === 0 ? -350 : 350 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.7 } },
      }
    : { hidden: { opacity: 1 }, visible: { opacity: 1 } };

  const boxVariantsPop = !isMobile
    ? {
        hidden: { opacity: 0, scale: 0.2 },
        visible: { opacity: 1, scale: 1, transition: { duration: 1 } },
      }
    : { hidden: { opacity: 1 }, visible: { opacity: 1 } };

  const boxVariantsY = !isMobile
    ? {
        hidden: { opacity: 0, y: index % 2 === 0 ? -350 : 350 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
      }
    : { hidden: { opacity: 1 }, visible: { opacity: 1 } };


    return(
<>
  <Row className="m-l-0 m-r-0 p-l-0 p-r-0">
        <Container fluid className="p-l-0 p-r-0 ">
          <Row style={{ margin: "0", padding: "0" }}>
            <Container>
              <Row className="mt-1">
                <Col xs={12} md={6} className="motion-container">
                  <h4 className="text-left un-leash-efficient-subheading mb-2">
                    NAU's VCMS eliminates the hassle of manual certificate
                    tracking by offering a comprehensive suite of features
                    designed to:
                  </h4>
                  {!isMobile ? (
                    <motion.div
                      variants={boxVariantsL}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0 }}
                    >
                      <ul className="list-items list-items-layout2 list-unstyled text-left">
                        <li>
                          Centralize Certificate Management: Maintain a
                          centralized repository for all your vessel, crew, and
                          class certificates, easily accessible from any
                          internet-connected device.{" "}
                        </li>
                        <li>
                          Automate Renewal Tracking: Define renewal dates for
                          each certificate and receive automated alerts well in
                          advance to ensure timely renewal.
                        </li>
                        <li>
                          Simplify Uploads and Storage: Upload electronic copies
                          of your certificates for secure storage and easy
                          retrieval.
                        </li>
                        <li>
                          Harmonized Surveys and Audits: Track internal and
                          external audits and harmonized surveys alongside
                          certificate information.
                        </li>
                        <li>
                          Predefined Certificate Schema: Benefit from a
                          predefined schema that includes common ship
                          certificates, ensuring you never miss a critical
                          renewal.
                        </li>
                        <li>
                          Multi-Reminder System: Set up multiple reminder
                          notifications via email or SMS to guarantee you stay
                          ahead of renewal deadlines.
                        </li>
                      </ul>
                    </motion.div>
                  ) : (
                    <div>
                      <ul className="list-items list-items-layout2 list-unstyled text-left">
                        <li>
                          Centralize Certificate Management: Maintain a
                          centralized repository for all your vessel, crew, and
                          class certificates, easily accessible from any
                          internet-connected device.{" "}
                        </li>
                        <li>
                          Automate Renewal Tracking: Define renewal dates for
                          each certificate and receive automated alerts well in
                          advance to ensure timely renewal.
                        </li>
                        <li>
                          Simplify Uploads and Storage: Upload electronic copies
                          of your certificates for secure storage and easy
                          retrieval.
                        </li>
                        <li>
                          Harmonized Surveys and Audits: Track internal and
                          external audits and harmonized surveys alongside
                          certificate information.
                        </li>
                        <li>
                          Predefined Certificate Schema: Benefit from a
                          predefined schema that includes common ship
                          certificates, ensuring you never miss a critical
                          renewal.
                        </li>
                        <li>
                          Multi-Reminder System: Set up multiple reminder
                          notifications via email or SMS to guarantee you stay
                          ahead of renewal deadlines.
                        </li>
                      </ul>
                    </div>
                  )}
                </Col>
                <Col xs={12} md={6}>
                  <img
                    src="/Images/LC/CertificatesLifeCycle.gif"
                    alt="Products"
                    className="img-fluid"
                    style={{
                      boxShadow: "#6b6b6b 1px 1px 4px",
                      borderRadius: "4px",
                    }}
                  />
                </Col>
              </Row>
              <Row className="mt-5 text-start">
                <Col xs={12} className="m-b-40 text-center">
                  <h1 className="un-leash-command-heading">
                    Streamlined Certificate Management
                  </h1>
                </Col>
              </Row>
            </Container>
            <Row className="m-l-0 m-r-0 p-l-0 p-r-0">
              <Col xs={12} className="p-l-0 p-r-0">
                <img
                  src="/Images/Mockups/ecloud-big.jpg"
                  alt=""
                  className="img-fluid"
                />
              </Col>
            </Row>
          </Row>
        </Container>
      </Row>

      <Row className="m-l-0 m-r-0 p-l-0 p-r-0">
        <Container>
          <Row className="motion-container">
            {!isMobile ? (
              <motion.div
                variants={boxVariantsPop}
                whileInView="whileInView"
                viewport={{ once: true }}
                initial="initial"
              >
                <Col xs={12} className="text-left m-t-40">
                  <h4 className="un-leash-command-subheading text-left">
                    Benefits of NAU's VCMS
                  </h4>
                  <h5 className="un-leash-efficient-paragraph">
                    By implementing NAU's VCMS, you can experience a multitude
                    of benefits, including:
                  </h5>
                  <div className="features1_component-copy text-left m-t-10">
                    <div className="features-item-1">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/TargetPeople.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              Enhanced Regulatory Compliance
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            Ensure your vessels always operate with valid
                            certificates, minimizing the risk of detentions and
                            fines.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="features-item-2">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/Key trends.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              Improved Operational Efficiency
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            Streamline certificate management processes and free
                            up valuable time for your staff.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="features-item-3">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/Stayaheadofremediationcosts-o.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              Increased Peace of Mind
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            Gain complete confidence knowing your certificates
                            are always up-to-date and readily accessible.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="features-item-4">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/Securepage.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              Improved Decision-Making
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            Access comprehensive certificate data to make
                            informed decisions regarding certificate renewal
                            priorities.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="features-item-5">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/KYBandUBOchecks.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">Reduced Costs</h3>
                          </div>
                          <p className="paragraph-11">
                            Avoid the financial penalties associated with
                            expired certificates.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </motion.div>
            ) : (
              <div>
                <Col xs={12} className="text-left m-t-40">
                  <h4 className="un-leash-command-subheading text-left">
                    Benefits of NAU's VCMS
                  </h4>
                  <h5 className="un-leash-efficient-paragraph">
                    By implementing NAU's VCMS, you can experience a multitude
                    of benefits, including:
                  </h5>
                  <div className="features1_component-copy text-left m-t-10">
                    <div className="features-item-1">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/TargetPeople.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              Enhanced Regulatory Compliance
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            Ensure your vessels always operate with valid
                            certificates, minimizing the risk of detentions and
                            fines.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="features-item-2">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/Key trends.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              Improved Operational Efficiency
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            Streamline certificate management processes and free
                            up valuable time for your staff.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="features-item-3">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/Stayaheadofremediationcosts-o.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              Increased Peace of Mind
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            Gain complete confidence knowing your certificates
                            are always up-to-date and readily accessible.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="features-item-4">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/Securepage.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">
                              Improved Decision-Making
                            </h3>
                          </div>
                          <p className="paragraph-11">
                            Access comprehensive certificate data to make
                            informed decisions regarding certificate renewal
                            priorities.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="features-item-5">
                      <div className="layout11_item">
                        <div className="layout11_icon-wrapper">
                          <img
                            src="/Images/SVG/KYBandUBOchecks.svg"
                            loading="lazy"
                            alt=""
                          />
                        </div>
                        <div className="layout11_content-wrapper">
                          <div className="margin-bottom margin-small">
                            <h3 className="heading-small">Reduced Costs</h3>
                          </div>
                          <p className="paragraph-11">
                            Avoid the financial penalties associated with
                            expired certificates.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </div>
            )}
          </Row>
        </Container>
      </Row>
</>
    );
}